<template>
  <Layout>
    <div class="bloco">
      <HeaderPage :pageTitles="pageTitles" />
      <div class="row">
        <div class="col">
          <b-form-group label="Rede">
            <b-form-select></b-form-select>
          </b-form-group>
        </div>
        <div class="col">
          <b-form-group label="Pesquisa por">
            <b-form-select v-model="pesquisa" :options="pesquisas"></b-form-select>
          </b-form-group>
        </div>
        <div class="col">
          <b-form-group :label="pesquisa">
            <b-form-input></b-form-input>
          </b-form-group>
        </div>
        <div class="col d-flex align-items-center">
          <b-button class="mt-3">
            Pesquisar
          </b-button>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'


export default {
  components: { Layout, HeaderPage },
  mixins: [],
  data() {
    return {
      pageTitles: {
        title: 'Cliente',
        subtitle: 'As opções de pesquisa de identidade, cartão de crédito bandeira, telefone, matrícula e cadastramento procuram apenas pelo cliente titular. As demais procuram pelos dependentes também'
      },
      pesquisa: 'CPF / CNPJ / ID',
      pesquisas: [
        'CPF / CNPJ / ID',
        'Cartão de crédito bandeira',
        'Telefone',
        'Matrĩcula',
        'Cadastramento'
      ]
    }
  },
  methods: {},
}
</script>

<style src="../style.scss" lang="scss">
</style>